import React from "react";
import TextBox from "devextreme-react/text-box";
import SelectBox from "devextreme-react/select-box";
import CheckBox from "devextreme-react/check-box";
import Button from "devextreme-react/button";

const visibilityOptions = [
  { id: "Private", name: "Private - only owner" },
  { id: "Group", name: "Group - shared users / roles" },
  { id: "Global", name: "Global - everyone" }
];

const shareTypeOptions = [
  { id: "User", name: "User" },
  { id: "Role", name: "Role" },
  { id: "Group", name: "Group" }
];

export default function SaveQueryPanel({
  queryName,
  setQueryName,
  queryDescription,
  setQueryDescription,
  visibility,
  setVisibility,
  shareType,
  setShareType,
  shareValue,
  setShareValue,
  shareCanEdit,
  setShareCanEdit,
  onSave,
  onRefreshSaved,
}) {
  return (
    <div className="card save-card">
      <h3>Save Query</h3>

      {/* TOP GRID */}
      <div className="save-grid">

        <div className="save_query">
          <label>Query Name</label>
          <TextBox
            value={queryName}
            placeholder="Example: Active Persons"
            onValueChanged={(e) => setQueryName(e.value)}
          />
        </div>

        <div className="save_query">
          <label>Description</label>
          <TextBox
            value={queryDescription}
            placeholder="Optional description"
            onValueChanged={(e) => setQueryDescription(e.value)}
          />
        </div>

        <div className="save_query">
          <label>Visibility</label>
          <SelectBox
            items={visibilityOptions}
            valueExpr="id"
            displayExpr="name"
            value={visibility}
            onValueChanged={(e) => setVisibility(e.value)}
          />
        </div>

        <div className="button-cell">
          <Button text="Save Query" type="success" onClick={onSave} className="savequery" />
        </div>

      </div>



      {/* SHARE SECTION */}
      {visibility === "Group" && (
        <div className="share-grid save_query">

          <div>
            <label>Share Type</label>
            <SelectBox
              items={shareTypeOptions}
              valueExpr="id"
              displayExpr="name"
              value={shareType}
              onValueChanged={(e) => setShareType(e.value)}
            />
          </div>

          <div className="save_query">
            <label>Share Value</label>
            <TextBox
              value={shareValue}
              placeholder="Role / User / Group"
              onValueChanged={(e) => setShareValue(e.value)}
            />
          </div>

          <div className="inline-check save_query">
            <CheckBox
              value={shareCanEdit}
              onValueChanged={(e) => setShareCanEdit(e.value)}
            />
            <span>Can edit</span>
          </div>

        </div>
      )}
          
          <div className="refreshsaved">
            <Button text="Refresh Saved" onClick={onRefreshSaved} />
          </div>
    </div>
  );
}